import { render, staticRenderFns } from "./orderInfoHeader.vue?vue&type=template&id=43dd60e0"
import script from "./orderInfoHeader.vue?vue&type=script&lang=js"
export * from "./orderInfoHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports